import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ObservationManagementService} from '../../../data/observations/observation-management.service';
import {ObservationTypeGroup} from '../../models/observation-group';
import {ToastService} from '../../services/toast.service';
import {MultiSelectComponent, MultiSelectFilter} from '../multi-select-component';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatDivider} from '@angular/material/divider';
import {MatButton} from '@angular/material/button';

/**
 * This component allows to create a multi-select filter of Observation Type Group entities.
 * It either emits 'undefined' value if no filter is set or an array of entities.
 *
 * In addition, it saves the state of the filter to URL params and browser's storage.
 */

@Component({
  selector: 'app-observation-group-filter',
  templateUrl: './observation-group-filter.component.html',
  styleUrls: ['./observation-group-filter.component.scss'],
  imports: [
    MatCheckbox,
    MatDivider,
    MatButton
  ]
})
export class ObservationGroupFilterComponent extends MultiSelectComponent<ObservationTypeGroup> implements OnInit {

  SETTINGS_KEY = 'selectedObservationTypeGroupIds';
  USE_FULLY_CHECKED_AS_DEFAULT = false;

  @Input() origin;
  @Output() filterChanged = new EventEmitter<MultiSelectFilter<ObservationTypeGroup>>();

  constructor(
    private readonly observationService: ObservationManagementService,
    private readonly toast: ToastService,
  ) {
    super();
  }

  ngOnInit() {
    this.observationService.getObservationTypeGroups()
      .then(response => {
        this.initComponent(response);
      }).catch(error => {
      console.log(error);
      this.toast.longer('Error while loading observation type groups!');
    });
  }

  getLabel(item: ObservationTypeGroup): string {
    return item.name;
  }

  onApply() {
  }

}
